import { render, staticRenderFns } from "./xinxidengji.vue?vue&type=template&id=500f8ac9&scoped=true"
import script from "./xinxidengji.vue?vue&type=script&lang=js"
export * from "./xinxidengji.vue?vue&type=script&lang=js"
import style0 from "./xinxidengji.vue?vue&type=style&index=0&id=500f8ac9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500f8ac9",
  null
  
)

export default component.exports